const SHOW_MODAL = "@app/showModal";
const HIDE_MODAL = "@app/hideModal";

export { SHOW_MODAL, HIDE_MODAL };
